// import _nanogallery from './../vendor/nanogallery.min';
var $ = jQuery.noConflict();
import _gallery from './../vendor/jquery.justifiedGallery.min';
import _lightbox from './../vendor/jquery.swipebox.min';
$(document).ready(function () {

if ( $( "#mygallery" ).length ) {
   portfolioGallery();
}

if ( $( ".offers-gallery-justified .grid" ).length ) {
   offersGallery();
}
        
});

function portfolioGallery(){
	$("#mygallery").justifiedGallery({
		captions:false,
		rowHeight: 200
	}).on('jg.complete', function () {
		$('#mygallery a').swipebox({
			useSVG : false,
			afterOpen : modalOpen,
        	afterClose : modalClose
		});
	});

}

function  offersGallery(){
	$(".offers-gallery-justified .grid").justifiedGallery({
		captions:false,
		rowHeight: 200
	}).on('jg.complete', function () {
		$('.offers-gallery-justified .grid a').swipebox({
			useSVG : false,
			afterOpen : modalOpen,
        	afterClose : modalClose
		});
	});

}

function modalOpen(){
	$('.justified-gallery').css('min-height',$('.justified-gallery').height());
  var hash = "gallery";
  window.location.hash = hash;
  window.onhashchange = function() {
    if (!location.hash){
      $('#swipebox-close').trigger('click');
    }
  }
}

function modalClose(){
  if( window.location.hash=="#gallery"){
    window.history.back();
	
	setTimeout(function(){
		$('.justified-gallery').css('min-height',0);
	}, 1000);

  }
}